module.exports = __webpack_public_path__ + "img/constelacion-logo.1496a6b9.svg";